import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Toast {
  id: number;
  message: string;
  type: 'success' | 'error' | 'warning';
  duration?: number;
}

export interface ConfirmOptions {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  danger?: boolean;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private toastId = 0;
  toasts$ = new BehaviorSubject<Toast[]>([]);
  confirm$ = new BehaviorSubject<{ options: ConfirmOptions; resolve: (result: boolean) => void } | null>(null);

  success(message: string) {
    this.addToast(message, 'success', 3000);
  }

  error(message: string) {
    this.addToast(message, 'error', 6000);
  }

  warning(message: string) {
    this.addToast(message, 'warning', 4000);
  }

  private addToast(message: string, type: Toast['type'], duration: number) {
    const id = ++this.toastId;
    const toast: Toast = { id, message, type, duration };
    this.toasts$.next([...this.toasts$.value, toast]);
    setTimeout(() => this.dismiss(id), duration);
  }

  dismiss(id: number) {
    this.toasts$.next(this.toasts$.value.filter(t => t.id !== id));
  }

  confirm(options: ConfirmOptions): Promise<boolean> {
    return new Promise(resolve => {
      this.confirm$.next({ options, resolve });
    });
  }
}
